import { enEmployeeInvite } from '../en';
import { frEmployeeInvite } from '../fr';
import { esEmployeeInvite } from '../es';
import { deEmployeeInvite } from '../de';

export const employeeInviteModuleTranslations = {
  en: enEmployeeInvite,
  fr: frEmployeeInvite,
  es: esEmployeeInvite,
  de: deEmployeeInvite,
} as const;

